import Cookies from "js-cookie";
import axios from "axios";
import { getBaseUrl } from "../../utils";

const baseUrl = "https://api.digibhakti.com/api/admin/puja";

export const getPuja_api = async (data) => {
  let config = {
    method: "get",
    url: `${baseUrl}?page=${data.page}&limit=${data.limit}&search=${data.search}&eventDate=${data?.event_date}&status=${data?.status}`,
    headers: {
      Authorization: `Bearer ${Cookies.get("token")}`,
      "Content-Type": "application/json",
    },
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getPujaById_api = async (id) => {
  let config = {
    method: "get",
    url: `${baseUrl}/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get("token")}`,
      "Content-Type": "application/json",
    },
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const deletePuja_api = async (id) => {
  let config = {
    method: "delete",
    url: `${baseUrl}/${id}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getPujaStatus_api = async (data) => {
  let config = {
    method: "patch",
    url: `${baseUrl}/${data?.id}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: { status: data?.status },
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const addPuja_api = async (data) => {
  let config = {
    method: "post",
    url: baseUrl,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const updatePuja_api = async (data, id) => {
  let config = {
    method: "patch",
    url: `${baseUrl}/${id}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};